import classNames from 'classnames';
import React, { memo } from 'react';
import { useDispatch } from 'react-redux';

import Button from '@wetransfer/transfer/component/form/element/button';
import VideoIllustration from '@wetransfer/transfer/component/illustration/video-illustration';
import Browser from '@wetransfer/transfer/modules/concorde-browser';
import I18n from '@wetransfer/transfer/modules/i18n';
import Router from '@wetransfer/transfer/modules/router';
import Actions from '@wetransfer/transfer/store/action';

export const Invalid = memo(() => {
  const dispatch = useDispatch();

  const handleClickNewTransfer = () => {
    dispatch(Actions.Transfer.create());
    Router.navigateTo('/');
  };

  let footerButton = (
    <button
      onClick={handleClickNewTransfer}
      className="transfer__button transfer__button--alt"
    >
      {I18n.t('transfer.buttons.new_transfer')}
    </button>
  );

  if (Browser.isMobile) {
    footerButton = (
      <Button
        onClick={handleClickNewTransfer}
        text={I18n.t('transfer.buttons.back_to_home')}
      />
    );
  }

  return (
    <div
      className={classNames('transfer__window', 'downloader', {
        'transfer__window--is-not-available': Browser.isMobile,
      })}
    >
      <div className="transfer__contents">
        <div className="downloader__expired">
          <VideoIllustration
            type="transfer-failed"
            src="transfer_window/transfer_error"
          />
          <h2>{I18n.t('transfer.failed.title')}</h2>
          <p>{I18n.t('transfer.failed.text')}</p>
        </div>
      </div>
      <div className="transfer__footer">{footerButton}</div>
    </div>
  );
});

Invalid.displayName = 'Invalid';
